import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PlatformUserContactInfo from '@/types/table/platformUserContactInfo';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PlatformUserContactInfoData extends PlatformUserContactInfo {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PlatformUserContactInfoController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PlatformUserContactInfoData>>(API_CONTEXT + '/app/platformUserContactInfo/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PlatformUserContactInfoData>(API_CONTEXT + '/app/platformUserContactInfo/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/platformUserContactInfo/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/platformUserContactInfo/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/platformUserContactInfo/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserContactInfo/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserContactInfo/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserContactInfo/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserContactInfo/deleteBatch', params, httpOptions);
  }
}
